import { NgModule } from '@angular/core';
import { RealtimeTrackingComponent } from './realtime-tracking.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { REALTIME_TRACKING_ROUTES } from './realtime-tracking.routes';
import { TripService } from './shared/trip.service';
import { FIREBASE_CONFIG } from '../core/firebase.config';
import { TripAddressComponent } from './trip-address/trip-address.component';
import { TrackATripComponent } from './track-a-trip/track-a-trip.component';
import { MessagingService } from './shared/messaging.service';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { LoadTrackingMapComponent } from './load-tracking-monitoring/load-tracking-map/load-tracking-map.component';
import { LoadTrackingMonitoringComponent } from './load-tracking-monitoring/load-tracking-monitoring.component';
import { LoadTrackingBucketComponent } from './load-tracking-monitoring/load-tracking-bucket/load-tracking-bucket.component';
import { LoadTrackingTripDetailsComponent } from './load-tracking-monitoring/load-tracking-map/load-tracking-trip-details/load-tracking-trip-details.component';
import { TripStatusComponent } from './trip-status/trip-status.component';
import { TripAddressRowComponent } from './trip-address/trip-address-row/trip-address-row.component';
import { TrackATripIntegrationComponent } from './track-a-trip-intergration/track-a-trip-integration.component';
import { EtaDetailsService } from './shared/eta-details.service';
import { TripDetailsCustomerComponent } from './trip-details-customer/trip-details-customer.component';
import { TripTimelineComponent } from './trip-timeline/trip-timeline.component';
import { FormsModule } from '@angular/forms';
import { TripInfoComponent } from './trip-info/trip-info.component';
import { LoadTrackingOverviewComponent } from './load-tracking-monitoring/load-tracking-overview/load-tracking-overview.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TripManagementService } from './shared/trip-management-service';
import { MapManagementService } from './shared/map-management-service';
import { DateTimezoneService } from './shared/date-timezone.service';
import { TimezoneDateComponent } from './timezone-date/timezone-date.component';


@NgModule({
    imports: [
        RouterModule.forChild(REALTIME_TRACKING_ROUTES),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(FIREBASE_CONFIG),
        SharedModule,
        FormsModule,
        InfiniteScrollModule,
    ],
  declarations: [
    RealtimeTrackingComponent,
    TripAddressComponent,
    TrackATripComponent,
    TrackATripIntegrationComponent,
    LoadTrackingMapComponent,
    LoadTrackingMonitoringComponent,
    LoadTrackingBucketComponent,
    LoadTrackingTripDetailsComponent,
    TripStatusComponent,
    TripAddressRowComponent,
    TripDetailsCustomerComponent,
    TripTimelineComponent,
    TripInfoComponent,
    LoadTrackingOverviewComponent,
    TimezoneDateComponent,
  ],
  providers: [
    TripService,
    EtaDetailsService,
    TripManagementService,
    MapManagementService,
    MessagingService,
    DateTimezoneService
  ]
})
export class RealtimeTrackingModule {
}
